import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center mb-4" }
const _hoisted_2 = { class: "text-lg text-gray-900 font-semibold mr-2" }
const _hoisted_3 = { class: "bg-blue-50 border border-blue-200 rounded-full py-1 px-2 text-center text-blue-600 text-xs font-medium" }
const _hoisted_4 = { class: "w-[18%] ml-10 hidden" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs mt-1 font-medium text-gray-600" }, "Expected License usage on Rollover.", -1)
const _hoisted_6 = { class: "lg-px-20" }
const _hoisted_7 = { class: "flex justify-between items-center w-full mb-6" }
const _hoisted_8 = { class: "w-2/3" }
const _hoisted_9 = { class: "text-sm mb-1" }
const _hoisted_10 = { class: "flex flex-row flex-wrap gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_17 = { class: "text-gray-600 font-medium text-sm mb-2" }
const _hoisted_18 = { class: "text-sm mb-7 text-sm font-medium text-gray-600" }
const _hoisted_19 = { class: "min-w-full w-full border-collapse border-spacing-0" }
const _hoisted_20 = { class: "columns" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_25 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_26 = { class: "flex flex-row gap-3" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = { class: "border-y border-y-gray-200 border-r border-r-gray-200 py-3 text-gray-600 font-medium text-xs text-start pr-6 last:rounded-tr-lg" }
const _hoisted_29 = { class: "flex flex-row gap-3" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = { class: "text-gray-900 text-sm font-medium py-6 border-b border-b-gray-200 pl-6 border-l border-l-gray-200 first:rounded-bl-lg" }
const _hoisted_32 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_33 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_34 = { class: "py-6 border-b border-b-gray-200" }
const _hoisted_35 = ["value", "disabled"]
const _hoisted_36 = { class: "py-6 border-b border-b-gray-200 pr-6 border-r border-r-gray-200 last:rounded-br-lg" }
const _hoisted_37 = ["value", "disabled"]
const _hoisted_38 = { class: "pagination w-full text-center my-8" }
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_41 = { class: "sm:flex sm:items-start" }
const _hoisted_42 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_43 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_44 = { class: "mt-2" }
const _hoisted_45 = { class: "text-sm text-gray-500" }
const _hoisted_46 = { class: "text-sm mt-2" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }

import { ref, watch, computed } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useRolloverStore } from "@/stores/rolloverStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { Learner } from "@/interfaces/learner.interface";
import { onBeforeMount } from "vue";
import { SchoolStructureClassGroup } from "@/interfaces/school-structure.interface";
import { Rollover } from "@/interfaces/rollover.interface";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import SchoolLicenseComponent from "@/components/global/SchoolLicenseComponent.vue";
import * as XLSX from "xlsx";

// stores
const maxVisibleClasses = 2;
const learnersPerPage = 8;
const maxVisiblePages = 3;
interface Event {
  target: {
    checked: boolean;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LearnersRolloverTableComponent',
  props: {
  gradeLevel: {
    type: Number,
    required: true,
  },
  isGoingBack: {
    type: Boolean,
    required: true,
  },
},
  emits: ["repeaters", "leavers"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();
const rolloverStore = useRolloverStore();
const licenseStore = useLicenseStore();
const subjectStore = useSubjectStore();

// Local State For tracking changes
const learners = ref<Learner[]>([] as Learner[]);
const learnersToRepeat = ref<string[]>([] as string[]);
const learnersToRemove = ref<string[]>([] as string[]);
// Computed, not read once: the subject list may still be loading when this mounts.
const mathsSubject = computed(() => subjectStore.getSubjects[0]?.id);

const numberOfLearnersToRepeat = computed(() => {
  // Filter learnersToRepeat to include only IDs that are also found in the learners array
  return learnersToRepeat.value.filter((id) =>
    learners.value.some((learner) => learner._id === id)
  ).length;
});
const numberOfLearnersToRemove = computed(() => {
  // Filter learnersToRemove to include only IDs that are also found in the learners array
  return learnersToRemove.value.filter((id) =>
    learners.value.some((learner) => learner._id === id)
  ).length;
});

// emite the learners to repeat and remove to parent component
// Define emits


watch(learnersToRepeat, () => {
  emit("repeaters", learnersToRepeat.value.length);
});

watch(learnersToRemove, () => {
  emit("leavers", learnersToRemove.value.length);
});

const classGroups = ref<SchoolStructureClassGroup[] | undefined>(
  [] as SchoolStructureClassGroup[]
);

// Local State for filtering and pagination
const searchQuery = ref("");
const classFilter = ref("");
const showModal = ref(false);
const repeatAllChecked = ref(false);
const removeAllChecked = ref(false);

const currentPage = ref(1);

const sortKey = ref<string | null>(null);
const sortOrder = ref<string>('asc');

const sortTable = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }
};

const filteredLearners = computed(() => {
  const query = searchQuery.value.toLowerCase();

  const learnersFilteredByName = learners.value.filter(
    (row) =>
      row.lastName.toLowerCase().includes(query) ||
      row.firstName.toLowerCase().includes(query) || row.email.toLowerCase().includes(query)
  );

  const learnersFilteredByClass = classFilter.value
    ? learnersFilteredByName.filter((row) =>
      row.classes.some((c) => c._id == classFilter.value)
    )
    : learnersFilteredByName;

  return learnersFilteredByClass;
});

const sortedLearners = computed(() => {
  if (!sortKey.value) return filteredLearners.value;

  return [...filteredLearners.value].sort((a, b) => {
    const aValue = a[sortKey.value as keyof Learner];
    const bValue = b[sortKey.value as keyof Learner];

    if (aValue < bValue) return sortOrder.value === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortOrder.value === 'asc' ? 1 : -1;
    return 0;
  });
});

const filteredAndPaginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * learnersPerPage;
  return sortedLearners.value.slice(start, start + learnersPerPage);
});

// Logic for pagination
const totalPages = computed(() =>
  Math.ceil(filteredLearners.value.length / learnersPerPage)
);

const goToPage = (pageNumber: any) => {
  currentPage.value = pageNumber;
};

const visiblePages = computed(() => {
  let start = Math.max(currentPage.value - Math.floor(maxVisiblePages / 2), 1);
  let end = Math.min(start + maxVisiblePages - 1, totalPages.value);

  // Adjust the start and end if we are at the end of the page range
  if (end >= totalPages.value) {
    start = Math.max(totalPages.value - maxVisiblePages + 1, 1);
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
});

// reset page 1 when search query changes to search from the beginning
watch(searchQuery, () => {
  currentPage.value = 1;
});

// reset page 1 when class filter changes to search from the beginning
watch(classFilter, () => {
  currentPage.value = 1;
});



onBeforeMount(() => {
  const rollover = rolloverStore.rollover as Rollover;

  // set the learners to repeat and remove from the rollover store
  if (rollover?.learnerActions) {
    learnersToRemove.value = rollover.learnerActions.leaving;
    learnersToRepeat.value = rollover.learnerActions.repeating;
  }

  emit("leavers", learnersToRemove.value.length);
  emit("repeaters", learnersToRepeat.value.length);

  classGroups.value = schoolStore.currentSchoolStructure?.classGroups.filter(
    (classGroup) => {
      return classGroup.gradeLevel === props.gradeLevel;
    }
  );

  learners.value = learnerStore.getSchoolLearners.filter(
    (learner) =>
      learner.grade === props.gradeLevel && learner.status === "active"
  );

  //increment expected licenses
  for (const learner of learners.value) {
    if (learner.classes && learner.classes.length > 0) {
      for (const cls of learner.classes) {
        const licenseProduct = licenseStore.getLicense?.products.find(
          (product) => product.product.subject === cls.subject._id
        );
        if (licenseProduct) {
          licenseStore.incrementSchoolLicenseSeatsUsed(licenseProduct._id);
        }
      }
    }
  }
});

__expose({
  learnersToRepeat,
  learnersToRemove,
});

const SelectAllStudentsRepeat = (event: Event) => {
  const checked = event.target.checked;
  repeatAllChecked.value = checked;

  if (checked) {
    learnersToRepeat.value = learners.value.map((learner) => learner._id);
    learnersToRemove.value = [];
    removeAllChecked.value = false; // Reset "Remove All"
  } else {
    learnersToRepeat.value = [];
  }
};

const SelectAllStudentsRemove = (event: Event) => {
  const checked = event.target.checked;
  removeAllChecked.value = checked;

  if (checked) {
    learnersToRemove.value = learners.value.map((learner) => learner._id);
    learnersToRepeat.value = [];
    repeatAllChecked.value = false; // Reset "Repeat All"
  } else {
    learnersToRemove.value = [];
  }
};

// Watch for individual checkbox state changes to ensure the header checkbox reflects it
watch(
  learnersToRepeat,
  (newValue) => {
    repeatAllChecked.value =
      newValue.length === learners.value.length && learners.value.length > 0;
  },
  { deep: true }
);

watch(
  learnersToRemove,
  (newValue) => {
    removeAllChecked.value =
      newValue.length === learners.value.length && learners.value.length > 0;
  },
  { deep: true }
);

const fileInput = ref<HTMLInputElement | null>(null);

const templateLink = computed(() => {
  const baseUrl = "https://storage.googleapis.com/reflective-learning-dash-dev.appspot.com/templates/";
  return `${baseUrl}rollover_bulk_grade_update.xlsx`;
});

const triggerFileUpload = () => {
  fileInput.value?.click();
};

const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target?.result as ArrayBuffer);
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    const headers = jsonData[0] as string[];
    const emailIndex = headers.indexOf("Email");
    const removeIndex = headers.indexOf("Remove");
    const repeatIndex = headers.indexOf("Repeat");

    const emailToUidMap = new Map<string, string>();
    learners.value.forEach((learner) => {
      emailToUidMap.set(learner.email, learner._id);
    });

    const newLearnersToRemove: string[] = [];
    const newLearnersToRepeat: string[] = [];

    for (let i = 1; i < jsonData.length; i++) {
      const row = jsonData[i] as string[];
      const email = row[emailIndex];
      const remove = row[removeIndex];
      const repeat = row[repeatIndex];
      const uid = emailToUidMap.get(email);

      if (uid) {
        if (remove && remove.toLowerCase() === "x" && repeat && repeat.toLowerCase() === "x") {
          // Skip if both "Remove" and "Repeat" are checked
          continue;
        }

        if (remove && remove.toLowerCase() === "x") {
          newLearnersToRemove.push(uid);
        } 
        
        if (repeat && repeat.toLowerCase() === "x") {
          newLearnersToRepeat.push(uid);
        }
      }
    }

    learnersToRemove.value = newLearnersToRemove;
    learnersToRepeat.value = newLearnersToRepeat;
  };

  reader.readAsArrayBuffer(file);
};

const confirmUpload = () => {
  showModal.value = false;
  triggerFileUpload();
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.grade")) + " " + _toDisplayString(__props.gradeLevel), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(numberOfLearnersToRepeat.value + numberOfLearnersToRemove.value) + " / " + _toDisplayString(learners.value.length), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.students_selected")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SchoolLicenseComponent, {
          showAllLicenses: true,
          layoutType: "horizontal"
        }),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.classes")), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (classFilter.value = '')),
              class: "bg-blue-50 rounded-lg px-4 py-2 text-sm text-gray-500 focus:text-gray-700 font-medium focus:font-semibold mb-2 border focus:border-blue-400"
            }, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.all")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classGroups.value?.slice(
            0,
            maxVisibleClasses + 1
          ), (classGroup, id) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-row flex-wrap",
                key: id
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (classFilter.value = classGroup._id),
                  class: "bg-blue-50 rounded-lg px-2 py-2 text-sm text-gray-500 focus:text-gray-700 font-medium focus:font-semibold mb-2 border focus:border-blue-400"
                }, [
                  _createTextVNode(_toDisplayString(classGroup.name) + " - ", 1),
                  (classGroup.subject === mathsSubject.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "M"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "E"))
                ], 8, _hoisted_11)
              ]))
            }), 128)),
            (classGroups.value && classGroups.value.length > maxVisibleClasses)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_FormKit, {
                    type: "select",
                    name: "moreClasses",
                    "outer-class": "select-btn text-gray-700",
                    placeholder: "More Classes",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (classFilter.value = '')),
                    modelValue: classFilter.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((classFilter).value = $event)),
                    options: classGroups.value?.slice(maxVisibleClasses + 1, classGroups.value?.length).map((classGroup) => {
                return {
                  label: `${classGroup.name} - ${classGroup.subject === mathsSubject.value ? 'M' : 'E'}`,
                  value: classGroup._id
                }
              })
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = true)),
              class: "bg-blue-50 rounded-lg px-4 py-2 text-sm text-gray-500 focus:text-gray-700 font-medium focus:font-semibold mb-2 border focus:border-blue-400"
            }, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.upload_button")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(MagnifyingGlassIcon), {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "search",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchQuery).value = $event)),
            placeholder: "Search student",
            class: "border border-gray-300 rounded-lg py-1.5 pl-10 pr-10 me-10 w-full text-sm leading-6"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ])
      ]),
      _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.info_text_one")), 1),
      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.info_text_two")), 1),
      _createElementVNode("table", _hoisted_19, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_20, [
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 border-l border-l-gray-200 py-3 text-gray-600 font-medium text-xs text-start pl-6 cursor-pointer first:rounded-tl-lg",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('firstName')))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.table.first_name")) + " ", 1),
              (sortKey.value === 'firstName' || sortKey.value === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start cursor-pointer",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('lastName')))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.table.last_name")) + " ", 1),
              (sortKey.value === 'lastName' || sortKey.value === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start cursor-pointer",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('email')))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.table.email")) + " ", 1),
              (sortKey.value === 'email' || sortKey.value === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.table.class")), 1),
            _createElementVNode("th", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.table.repeat")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")), 1),
                _createElementVNode("input", {
                  type: "checkbox",
                  onChange: SelectAllStudentsRepeat,
                  checked: repeatAllChecked.value,
                  class: "h-4 w-4 border border-blue-600"
                }, null, 40, _hoisted_27)
              ])
            ]),
            _createElementVNode("th", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createTextVNode(_toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.table.remove")) + " ", 1),
                _createElementVNode("input", {
                  type: "checkbox",
                  onChange: SelectAllStudentsRemove,
                  checked: removeAllChecked.value,
                  class: "h-4 w-4 border border-blue-600"
                }, null, 40, _hoisted_30)
              ])
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAndPaginatedLearners.value, (learner, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: "mb-1"
            }, [
              _createElementVNode("td", _hoisted_31, _toDisplayString(learner.firstName), 1),
              _createElementVNode("td", _hoisted_32, _toDisplayString(learner.lastName), 1),
              _createElementVNode("td", _hoisted_33, _toDisplayString(learner.email), 1),
              _createElementVNode("td", {
                class: _normalizeClass(["text-gray-600 text-sm py-6 border-b border-b-gray-200", { 'text-red-500': learner?.classes && learner?.classes.length == 0 }])
              }, _toDisplayString(learner.classes && learner.classes.length > 0
                ? learner.classes
                  .map(
                    (classItem) =>
                      `${classItem.name} - ${classItem.subject.name.charAt(
                        0
                      )}`
                  )
                  .join(", ")
                : "UNASSIGNED"), 3),
              _createElementVNode("td", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: learner._id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((learnersToRepeat).value = $event)),
                  disabled: learnersToRemove.value.includes(learner._id),
                  class: "h-4 w-4 border border-blue-600"
                }, null, 8, _hoisted_35), [
                  [_vModelCheckbox, learnersToRepeat.value]
                ])
              ]),
              _createElementVNode("td", _hoisted_36, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: learner._id,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((learnersToRemove).value = $event)),
                  disabled: learnersToRepeat.value.includes(learner._id),
                  class: "h-4 w-4 border border-blue-600"
                }, null, 8, _hoisted_37), [
                  [_vModelCheckbox, learnersToRemove.value]
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (pageNumber) => {
          return (_openBlock(), _createElementBlock("button", {
            key: pageNumber,
            onClick: ($event: any) => (goToPage(pageNumber)),
            disabled: pageNumber === currentPage.value,
            class: "text-gray-700 p-2.5 text-xs font-medium me-2.5 rounded-lg leading-none pag-btn border border-gray-300 disabled:border-blue-600 bg-white disabled:bg-blue-200"
          }, _toDisplayString(pageNumber), 9, _hoisted_39))
        }), 128))
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: showModal.value,
      onLocalModalOpen: _cache[11] || (_cache[11] = ($event: any) => (showModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.upload_title")), 1),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.upload_description")), 1),
                _createElementVNode("p", _hoisted_46, [
                  _createElementVNode("a", {
                    href: templateLink.value,
                    target: "_blank"
                  }, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.upload_template")), 9, _hoisted_47)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("button", {
            onClick: confirmUpload,
            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
          }, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.upload_confirm")), 1),
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (showModal.value = false)),
            class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
          }, _toDisplayString(_ctx.$t("rollover.learner_rollover_table_screen.upload_cancel")), 1)
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("input", {
      type: "file",
      ref_key: "fileInput",
      ref: fileInput,
      onChange: handleFileUpload,
      class: "hidden"
    }, null, 544)
  ], 64))
}
}

})